import React, { Dispatch, SetStateAction } from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import { classes } from './styles';
import FormRadioButtonGroup from '../../Components/CustomUIElements/FormRadioButtonGroup';
import FormCheckboxGroup from '../../Components/CustomUIElements/FormCheckboxGroup';
import { Virtualize } from '../../Components/CustomUIElements/VirtualizedAutocomplete';
import { sharedClasses } from '../../Components/CustomUIElements/sharedClasses';
import { IStyle } from '../../../ThemeContext/ThemeObject';
import { newJobsConfig } from '../config';

export default function NewJobStep1({
  createType,
  setCreateType,
  clonedJob,
  setClonedJob,
  jobOptions,
  jobDefaultOptions,
  getJob,
  error,
  resources,
  setResources
}: {
  createType: string;
  setCreateType: Dispatch<SetStateAction<string>>;
  clonedJob: string | null;
  setClonedJob: Dispatch<SetStateAction<string | null>>;
  jobOptions: string[];
  jobDefaultOptions: { id: number; reference: string; title: string }[];
  getJob: (id: number) => void;
  error: boolean;
  resources: Record<string, boolean>;
  setResources: Dispatch<SetStateAction<Record<string, boolean>>>;
}) {
  return (
    <Box sx={classes.modalContent} id="new-job-modal-content" aria-label="New job modal content">
      <Box id="new-job-modal-title" sx={classes.modalHeaderContent}>
        Would you like to clone from an existing job or create a new one?
      </Box>
      <Box role="form" id="new-job-form" aria-label="New job form">
        <Box sx={classes.fullWidthFieldContainer}>
          <Box sx={classes.cloneJobInput}>
            <FormRadioButtonGroup
              options={[
                // { label: 'Use job template', value: 'Use job template' },
                { label: 'Clone existing job', value: 'Clone existing job' },
                { label: 'Create new', value: 'Create new' }
              ]}
              onChange={(value) => setCreateType(value as string)}
              directionRow={true}
              color={'#838383'}
              defaultValue={createType}
              groupLabel={''}
            />
          </Box>
          {createType === 'Use job template' && (
            <Autocomplete
              disablePortal
              options={['template1', 'template2', 'template3']} // TO BE CHANGED WHEN ENDPOINT IS READY
              sx={{
                ...sharedClasses.formAutocomplete,
                marginTop: 4,
                paddingRight: '4px'
              }}
              onChange={(e, value) => console.log(value)}
              slotProps={{ listbox: { style: sharedClasses.autoCompleteListStyles } }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Choose template"
                  slotProps={{ inputLabel: { shrink: true } }}
                />
              )}
            />
          )}
          {createType === 'Clone existing job' && (
            <Box>
              <Box sx={{ margin: '2rem 0', position: 'relative' }}>
                <Virtualize
                  value={clonedJob}
                  passOptions={jobOptions}
                  setValue={async (event: string, value: string) => {
                    const index = Number(event);
                    if (typeof index === 'number') {
                      const reference = value.split(' -')[0];
                      const i = jobDefaultOptions.findIndex(
                        (option) => option?.reference === reference
                      );
                      setClonedJob(value);
                      getJob(jobDefaultOptions[i >= 0 ? i : index]?.id);
                    }
                  }}
                  hasIdAndRef={true}
                  passedStyles={{ width: '99.5%', ...classes.formAutocomplete } as IStyle}
                  errorStyles={{ ...sharedClasses.errorBox, top: '-24px', right: '0px' } as IStyle}
                  label="Choose job"
                />
                {error && <Box sx={classes.errorBox}>This field is required</Box>}
              </Box>
              <Box sx={classes.fullWidthFieldContainer}>
                <FormCheckboxGroup
                  options={newJobsConfig.resource_field_choices.map((resource) => ({
                    name: resource.name,
                    id: resource.id,
                    tip: ''
                  }))}
                  directionRow={true}
                  defaultValues={resources}
                  onChange={(value) => setResources(value)}
                  groupLabel={'Choose resources to import'}
                  color={'#838383'}
                />
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
